import { render, staticRenderFns } from "./ArtPerfDef.vue?vue&type=template&id=5be23cf5&"
import script from "./ArtPerfDef.vue?vue&type=script&lang=ts&"
export * from "./ArtPerfDef.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports